import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-warning-icon',
    templateUrl: './warning-icon.component.html',
    styleUrls: ['./warning-icon.component.scss'],
    standalone: false
})
export class WarningIconComponent {
    @Input() name: string;
    @Input() type: boolean;
    @Input() bIsOrder: boolean;
    @Input() bIsCheckForLOVEntry: boolean;
}
